import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material"
import { MetaDrivenTable, PaginationControls, StatusChip } from "../../../shared/components"
import { formatCurrency } from "../../../shared/utils";
import { useCommercialData } from "../../commercialsDashboard/hooks/useCommercialData";

export const BudgetCastList = () => {

    const { data: commercialData, isLoading: isCommercialDataLoading, isError: isCommercialDataError, error: commercialDataError, pagination, changePage, changeRowsPerPage } = useCommercialData();

    const headers = [
        { "alias_name": "project", "label": "Project", "display_order": 1, is_show: true },
        { "alias_name": "budget", "label": "Budget", "display_order": 2, is_show: true },
        { "alias_name": "actual_spend", "label": "Actual", "display_order": 3, is_show: true },
        { "alias_name": "current_eac", "label": "Forecast EAC", "display_order": 4, is_show: true },
        { "alias_name": "variance_value", "label": "Variance", "display_order": 5, is_show: true },
        { "alias_name": "variance_percent", "label": "Variance %", "display_order": 6, is_show: true },
        { "alias_name": "percent_spent", "label": "% Spent", "display_order": 7, is_show: true },
        { "alias_name": "rag_status", "label": "RAG", "display_order": 8, is_show: true },
    ];

    const metrics = {
        project: {
            type: 'component',
            element: ((data: { project: string, project_reference: string }) => (
                <>
                    <Typography variant="body2" color="text.primary">{data.project}</Typography>
                    <Typography variant="caption" color="text.secondary">{data.project_reference}</Typography>
                </>
            ))
        },
        budget: {
            type: 'component',
            element: ((data: { budget: number }) => (
                <>{formatCurrency(data.budget)}</>
            ))
        },
        actual_spend: {
            type: 'component',
            element: ((data: { actual_spend: number }) => (
                <>{formatCurrency(data.actual_spend)}</>
            ))
        },
        current_eac: {
            type: 'component',
            element: ((data: { current_eac: number }) => (
                <>{formatCurrency(data.current_eac)}</>
            ))
        },
        variance_value: {
            type: 'component',
            element: ((data: { variance_value: string }) => (
                <Typography>{formatCurrency(Number(data.variance_value))}</Typography>
            ))
        },
        variance_percent: {
            type: 'component',
            element: ((data: { variance_percent: string }) => (
                <Typography>{data.variance_percent}%</Typography>
            ))
        },
        percent_spent: {
            type: 'component',
            element: ((data: { percent_spent: string }) => (
                <Typography>{data.percent_spent}%</Typography>
            ))
        },
        rag_status: {
            type: 'component',
            element: ((data: { rag_status: string }) => (
                <StatusChip label={data.rag_status} color={data.rag_status === 'Green' ? 'green' : data.rag_status === 'Amber' ? 'amber' : data.rag_status === 'Red' ? 'red' : 'default'} />
            ))
        },
    };

    if (isCommercialDataLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isCommercialDataError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {commercialDataError?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    }

    return (
        <Paper variant="outlined" sx={{ m: 2, pt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2 }}>Project Performance Detail</Typography>
            <MetaDrivenTable headers={headers} data={commercialData} dataMetrics={metrics} sortDisabled />
            <PaginationControls total={pagination.total} rowsPerPage={pagination.limit} currentPage={pagination.page} handlePageChange={changePage} handleRowsPerPage={changeRowsPerPage} />
        </Paper>
    );

};